import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.4038 3.92719C5.13189 3.73664 4.7753 3.73891 4.50565 3.93289C4.236 4.12688 4.10853 4.47285 4.18457 4.8043L7.99607 21.4176C8.07212 21.749 8.33611 21.9981 8.66099 22.0449C8.98588 22.0916 9.30512 21.9266 9.46507 21.6291L12.4976 15.9891L18.2113 14.5744C18.5186 14.4983 18.7534 14.2408 18.8099 13.9179C18.8663 13.5951 18.7337 13.2682 18.4719 13.0847L5.4038 3.92719Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgMouseCursor = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMouseCursor;
